var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAppTlm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 6,
    width: 18,
    height: 32,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11.8293C27.1872 11.9398 26.8506 12 26.5 12H5.5C5.14936 12 4.81278 11.9398 4.5 11.8293M27.5 11.8293C28.6652 11.4175 29.5 10.3062 29.5 9C29.5 7.34315 28.1569 6 26.5 6H5.5C3.84315 6 2.5 7.34315 2.5 9C2.5 10.3062 3.33481 11.4175 4.5 11.8293M27.5 11.8293V19.1707M27.5 19.1707C27.1872 19.0602 26.8506 19 26.5 19H5.5C5.14936 19 4.81278 19.0602 4.5 19.1707M27.5 19.1707C28.6652 19.5825 29.5 20.6938 29.5 22C29.5 23.3062 28.6652 24.4175 27.5 24.8293M27.5 24.8293C27.1872 24.9398 26.8506 25 26.5 25H5.5C5.14936 25 4.81278 24.9398 4.5 24.8293M27.5 24.8293V32.1707M27.5 32.1707C28.6652 32.5825 29.5 33.6938 29.5 35C29.5 36.6569 28.1569 38 26.5 38H5.5C3.84315 38 2.5 36.6569 2.5 35C2.5 33.6938 3.33481 32.5825 4.5 32.1707M27.5 32.1707C27.1872 32.0602 26.8506 32 26.5 32H5.5C5.14936 32 4.81278 32.0602 4.5 32.1707M4.5 32.1707L4.5 24.8293M4.5 24.8293C3.33481 24.4175 2.5 23.3062 2.5 22C2.5 20.6938 3.33481 19.5825 4.5 19.1707M4.5 19.1707V11.8293",
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 8H41V12.5M41 12.5H37.5M41 12.5V17M41 17H34.5M41 17V22M41 22H37.5M41 22V27M41 27H34.5M41 27V32M41 32V37H34.5M41 32H37.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppTlm);
export default __webpack_public_path__ + "static/media/icon-app-tlm.9c330a92e49519b4ef747c7845eb3543.svg";
export { ForwardRef as ReactComponent };